import { ListModeUI } from "@/constants/default";
import useColorMode from "@/hook/useColorMode";
import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function DropdownDarkMode() {
    useTranslation();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const {colorMode, setColorMode} = useColorMode();
    const trigger = useRef<any>(null);
    const dropdown = useRef<any>(null);

    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }: MouseEvent) => {
            if (!dropdown.current) return;
            if (
                !dropdownOpen ||
                dropdown.current.contains(target) ||
                trigger.current.contains(target)
            )
                return;
            setDropdownOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (!dropdownOpen || keyCode !== 27) return;
            setDropdownOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    return (
        <div className="relative">
            <Link
                ref={trigger}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-4"
                to="#"
            >
                <span className="rounded-full">
                    <i className={_.find(ListModeUI(), item => item.value === colorMode.toString())?.icon} />
                </span>
            </Link>

            {/* <!-- Dropdown Start --> */}
            <div
                ref={dropdown}
                onFocus={() => setDropdownOpen(true)}
                onBlur={() => setDropdownOpen(false)}
                className={`absolute right-0 mt-7 w-40 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark ${dropdownOpen === true ? 'block' : 'hidden'}`}
            >
                <ul className="flex flex-col gap-5 border-b border-stroke px-6 py-4 dark:border-strokedark">
                    {
                        ListModeUI().map(item => (
                            <li
                                key={item.value}
                                className="cursor-pointer"
                                onClick={() => {
                                    if (typeof setColorMode === 'function') {
                                        setColorMode(item.value);
                                    }
                                    setDropdownOpen(false)
                                }}
                            >
                                <span className="flex items-center gap-3.5 text-sm font-medium duration-300 ease-in-out hover:text-primary lg:text-base">
                                    <i className={item.icon} />
                                    {item.label}
                                </span>
                            </li>
                        ))
                    }
                </ul>
            </div>
            {/* <!-- Dropdown End --> */}
        </div>
    );
}
